/**
 * Este é um wrapper para a função 'fetch' nativa.
 * 1. Adiciona automaticamente o token de autorização em todas as requisições.
 * 2. Intercepta respostas com status 401 (Não Autorizado/Token Expirado).
 * 3. Se um erro 401 ocorrer, limpa o token do localStorage e redireciona
 * o usuário para a página de login, forçando um logout seguro.
 */
export const authFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
    const token = localStorage.getItem('ccomex_token');
  
    // Cria um novo objeto de Headers baseado nos headers da chamada original
    const headers = new Headers(options.headers);
  
    // Adiciona o token de autorização se ele existir
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
  
    // Define 'Content-Type' como JSON por padrão, mas apenas se não for um upload de arquivo (FormData)
    // e se nenhum 'Content-Type' já tiver sido definido na chamada original.
    if (!headers.has('Content-Type') && !(options.body instanceof FormData)) {
      headers.set('Content-Type', 'application/json');
    }
  
    // Faz a chamada real para a API com os headers atualizados
    const response = await fetch(url, {
      ...options,
      headers,
    });
  
    // Se a resposta for 401, o token é inválido ou expirou.
    if (response.status === 401) {
      // Remove o token antigo para evitar loops
      localStorage.removeItem('ccomex_token');
      
      // Redireciona o usuário para a página de login.
      window.location.href = '/login';
  
      // Lança um erro para interromper a execução do código que fez a chamada.
      throw new Error('Sua sessão expirou. Você será redirecionado para o login.');
    }
  
    // Se a resposta for qualquer outra coisa, retorna como de costume.
    return response;
  };
  